import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { Card, CardHeader, Collapse } from 'reactstrap';
import { UpOutlined, DownOutlined } from '@ant-design/icons';

const column1 = [
  {
    Header: 'Part Number',
    accessor: 'partNum',
  },
  {
    Header: 'NSN',
    accessor: 'niin',
  },
  {
    Header: 'Part Description',
    accessor: 'description',
  },
  {
    Header: 'CAGE',
    accessor: 'cage',
  },
  {
    Header: 'Company Name',
    accessor: 'company',
  },
  {
    Header: 'Price',
    accessor: 'price',
  }, {
    Header: 'UI',
    accessor: 'ui',
  },
  {
    Header: 'QUP',
    accessor: 'qup',
  },
  {
    Header: 'SOH',
    accessor: 'soh',
  },
  {
    Header: 'Visibility',
    accessor: 'public',
  },
];

const Header = data => {
  const [toggleQuestion, setToggequestion] = useState(1);
  return (
    <div className="nf-u-details__grid">
      <Card className="nf-solicitation-detail__card">
        <CardHeader
          className="nf-solicitation-detail__card-header"
          onClick={() => setToggequestion(!toggleQuestion)}
        >
          Stock On Hand {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
        </CardHeader>

        <Collapse isOpen={toggleQuestion}>
          <ReactTable
            data={data.block}
            columns={column1}
            defaultPageSize={data.block.length > 0 ? data.block.length : 3}
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
        </Collapse>
      </Card>

      {/* <Table dataSource={drawings} columns={columns} /> */}
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/niinDetailTables/StockOnHand.jsx